export const PRICES = {
    usd: { monthly: 79, yearly: 69, yearlyTotal: 828, monthlyAnnual: 948, symbol: '$', code: 'USD' },
    cad: { monthly: 109, yearly: 96, yearlyTotal: 1152, monthlyAnnual: 1308, symbol: '$', code: 'CAD' }
};

export const PLAN_FEATURES = [
    'Unlimited SOAPs, summaries and callbacks',
    'Voice dictation on phone and desktop',
    'Unlimited PetQuery AI assistant',
    'Cases that keep each patient together',
    'Custom templates',
    'Priority support'
];

export const TRIAL_DAYS = 10;

export const FREE_DAILY = { soap: 2, query: 3 };
